"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YandexMetricaProvider = exports.MetricaTagIDContext = void 0;
const script_1 = __importDefault(require("next/script"));
const react_1 = __importStar(require("react"));
const useTrackRouteChange_1 = require("../hooks/useTrackRouteChange");
const MetricaPixel_1 = require("./MetricaPixel");
exports.MetricaTagIDContext = (0, react_1.createContext)(null);
const YandexMetricaProvider = ({ children, tagID, strategy = 'afterInteractive', initParameters, shouldUseAlternativeCDN = false, }) => {
    const YANDEX_METRICA_ID = process.env.NEXT_PUBLIC_YANDEX_METRICA_ID;
    const id = (0, react_1.useMemo)(() => {
        return tagID || (YANDEX_METRICA_ID ? Number(YANDEX_METRICA_ID) : null);
    }, [YANDEX_METRICA_ID, tagID]);
    (0, useTrackRouteChange_1.useTrackRouteChange)({ tagID: id });
    if (!id) {
        console.warn('[next-yandex-metrica] Yandex.Metrica tag ID is not defined');
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    const scriptSrc = shouldUseAlternativeCDN
        ? 'https://cdn.jsdelivr.net/npm/yandex-metrica-watch/tag.js'
        : 'https://mc.yandex.ru/metrika/tag.js';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(script_1.default, { id: "yandex-metrica", strategy: strategy }, `
          (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
          m[i].l=1*new Date();
          for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
          k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
          (window, document, "script", "${scriptSrc}", "ym");
          ym(${id}, "init", ${JSON.stringify(initParameters || {})});
        `),
        react_1.default.createElement("noscript", { id: "yandex-metrica-pixel" },
            react_1.default.createElement(MetricaPixel_1.MetricaPixel, { tagID: id })),
        react_1.default.createElement(exports.MetricaTagIDContext.Provider, { value: id }, children)));
};
exports.YandexMetricaProvider = YandexMetricaProvider;
//# sourceMappingURL=YandexMetricaProvider.js.map